import userIdentificationTypeConstants from "constants/userIdentificationType";

export default function calculateFinalBankAccount(bankAccountsForm) {
  const {bank, bankAccountNoMojAs, bankAccountMojAs} = bankAccountsForm;
  const loggedIn = bankAccountsForm.userIdentificationType !== userIdentificationTypeConstants.MANUAL;

  return loggedIn
    ? {bankAccount: bankAccountMojAs, bank}
    : {bankAccount: bankAccountNoMojAs, bank};
}